import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import './index.css';
import App from './App';

const rootElement = document.getElementById('root');
const app = (
  <React.StrictMode>
    <HelmetProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </HelmetProvider>
  </React.StrictMode>
);

// Pre-rendering writes HTML into #root during build, tagged with the route it
// was generated for. Firebase's catch-all rewrite serves build/index.html
// (the "/" prerender) for every route that isn't a static file, so #root can
// be non-empty on routes like /login or /niva that were never prerendered —
// hydrating against that mismatched markup throws React errors #418/#423.
// Only hydrate when the tagged route actually matches where we landed.
const prerenderedRoute = rootElement.dataset.prerenderedRoute;
if (rootElement.hasChildNodes() && prerenderedRoute === window.location.pathname) {
  ReactDOM.hydrateRoot(rootElement, app);
} else {
  ReactDOM.createRoot(rootElement).render(app);
}
